import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { toast } from "react-toastify";
import ErrorProps from "../../../Component/Errorprops";
import { useSearchParams } from "react-router-dom";
import { decode } from "../../../Component/JWT/Formatt";

const ComponentItemModal = ({ mode, handleCloseClick, editData }) => {
  const [loading, setLoading] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();
  const comId=decode(searchParams.get("id"))

  useEffect(() => {
    getData()
  }, []);

  const getData = async () => {




  }

  const initialValue = {
    itemCode: mode === "Edit" ? editData.itemCode : "",
    itemName: mode === "Edit" ? editData.itemName : "",
    description: mode === "Edit" ? editData.description : "",
    subUnitCategory : mode === "Edit" ? editData.subUnitCategory  : "",
    componentProfileId : mode === "Edit" ? editData.componentProfileId  : comId,
  };
  const validationSchema = Yup.object().shape({
    itemCode: Yup.string().required("This field is required"),
    itemName: Yup.string().required("This field is required"),
    subUnitCategory: Yup.string().required("This field is required"),
  });
  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true)
    const createLink = masterAPI["componentItem"].create;
    const updateLink = masterAPI["componentItem"].update
    if (mode === "Create") {
      await axiosPrivate.post(`${createLink}`, value).then(res => {
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e => {
        setLoading(false)
        console.log(e, "componentItem")
      })
    } else {
      const updateAC = {
        id: editData.id,
        ...value
      }
      await axiosPrivate.put(`${updateLink}`, updateAC).then(res => {
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e => {
        setLoading(false)
        console.log(e, "componentItem")
      })
    }

  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? editData.code + "-" + editData.itemName : "New Component Item"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
               <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Item Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="itemCode"
                  placeholder="Enter Item Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="itemCode">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Item Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="itemName"
                  placeholder="Enter Item Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="itemName">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Description
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="description"
                  placeholder="Enter Description"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                {/* <ErrorMessage name="techSpecName">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage> */}
              </Grid>
             <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Sub Unit Category
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="subUnitCategory"
                  placeholder="Enter Sub Unit Category"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="subUnitCategory">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
             
              <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{

                    textTransform: "none",
                    backgroundColor: loading ? "default" : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ComponentItemModal;
